/**
 * @desc 油卡解锁
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.OilCardUnlockParameters): Promise<BaseResponse<defs.ResultBean<defs.TheUnlockCardDetails>>> {
  return fetch({
    url: config.API_HOST + '/statistics/orderLimitOperUnlock',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
